import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import hero from "../assets/ha1.webp";
import hero2 from "../assets/ha2.webp";
import hero3 from "../assets/ha3.webp";
/* ================= SLIDER DATA ================= */

const heroSlides = [
  {
    small: "Overseas Education & Immigration",
    title1: "Your Journey to a",
    highlight: "Global Future",
    title2: "Starts Here",
    description:
      "Expert overseas consultancy for education, work visas, and immigration. Personalized guidance trusted by thousands worldwide.",
    image: hero,
  },
  {
    small: "Study • Work • Settle Abroad",
    title1: "Build Your",
    highlight: "International Career",
    title2: "With Confidence",
    description:
      "From world-class universities to global careers, we help you unlock opportunities across top destinations.",
    image:hero2,
  },
 {
  small: "Personalized Study Abroad Guidance at Your Home",
  title1: "Expert",
  highlight: "Door-to-Door Counselling",
  title2: "For Overseas Education Success",
  description:
    "One-on-one study abroad counselling delivered at your doorstep. Get expert guidance on course selection, university shortlisting, financial planning, and visa pathways — tailored to your academic goals.",
  image: hero3,
}

];

/* ================= TRUST LOGOS ================= */

const universities = [
  // Harvard
  "https://upload.wikimedia.org/wikipedia/commons/c/cc/Harvard_University_coat_of_arms.svg",

  // University of Toronto
  "https://upload.wikimedia.org/wikipedia/en/0/04/Utoronto_coa.svg",

  // University of Melbourne
  "https://upload.wikimedia.org/wikipedia/en/b/b4/The_University_of_Melbourne_Coat_of_Arms.svg",

  // University of Oxford
  "https://upload.wikimedia.org/wikipedia/commons/e/e4/Arms_of_University_of_Oxford.svg",

  // University of Sydney
  "https://upload.wikimedia.org/wikipedia/en/9/9a/University_of_Sydney_coat_of_arms.png",

  "https://upload.wikimedia.org/wikipedia/commons/c/c3/Coat_of_Arms_of_the_University_of_Cambridge.svg",

  "https://upload.wikimedia.org/wikipedia/commons/9/92/UPenn_shield_with_banner.svg",

  "https://upload.wikimedia.org/wikipedia/commons/9/93/Seal_of_the_University_of_Michigan.svg"
  
];



export default function HeroAuto() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative overflow-hidden min-h-screen">

  {/* ================= BACKGROUND IMAGE SLIDER ================= */}
  <div className="absolute inset-0">
    <AnimatePresence mode="wait">
      <motion.div
        key={active}
        className="absolute inset-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
      >
        <img
          src={heroSlides[active].image}
          alt=""
           className="
    w-full h-full object-cover
    object-top
    sm:object-center
    lg:object-center
  "
        />

        {/* SINGLE CLEAN OVERLAY */}
        <div className="absolute inset-0 bg-black/55" />
      </motion.div>
    </AnimatePresence>
  </div>

  {/* ================= CONTENT ================= */}
  <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex items-center min-h-screen">

      <AnimatePresence mode="wait">
        <motion.div
          key={active}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl text-center lg:text-left space-y-6"
        >
          <span className="inline-block px-4 py-2 bg-white/20 text-white text-xs sm:text-sm rounded-full backdrop-blur">
            {heroSlides[active].small}
          </span>

          <h1 className="font-extrabold leading-tight text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            {heroSlides[active].title1}{" "}
            <span className="text-[#93C5FD]">
              {heroSlides[active].highlight}
            </span>{" "}
            {heroSlides[active].title2}
          </h1>

          <p className="text-lg text-white/90 leading-relaxed">
            {heroSlides[active].description}
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#1E3A8A] rounded-full uppercase text-sm tracking-wider font-semibold hover:bg-white/90 transition shadow-xl"
            >
              Free Consultation
              <ArrowRight className="w-4 h-4" />
            </Link>

            <Link
              to="/services"
              className="inline-flex items-center gap-3 px-8 py-4 border border-white/50 rounded-full text-white uppercase text-sm tracking-wider hover:bg-white/10 transition"
            >
              Explore Services
            </Link>
          </div>

          {/* TRUST LOGOS */}
          <div className="pt-10">
            <p className="text-white/70 text-xs uppercase tracking-wider mb-4">
              Partner Universities
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-6">
              {universities.map((logo, i) => (
                <img
                  key={i}
                  src={logo}
                  alt="University"
                  className="h-9 object-contain opacity-90 hover:opacity-100 transition"
                />
              ))}
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

    </div>
  </div>

</section>

  );
}
